module.exports = __webpack_public_path__ + "static/media/premium2.e8f58df7.png";